import { ref } from 'vue'

export const showSectionManagement = ref(false)
